"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setLogLevel = exports.resetActiveLoggersToOriginalLevel = exports.addLogger = exports.getConfig = exports.initializeConfig = exports.waitForLoggersToGC = exports.pino = void 0;
/**
 * This Library is intended to be a singleton; thus, only one version is expected to be loaded. However, due to the fact
 * that we support a dual package setup (we publish both ESM and CJS); we've run into an issue where both the CJS and ESM
 * versions of the library are loaded by an application. This was happening when a next.js application dependent on this
 * library directly, but also leveraged a cjs only library that also depended on this library.
 *
 * See https://nodejs.org/api/packages.html#dual-package-hazard for an in-depth analysis of the dual package hazard problem.
 *
 * We have opted for Approach #2 - 'Isolate State' - described in that document by moving the shared state we expect to a cjs file
 * that is loaded by both the ESM and CJS packages.
 */
const pino_1 = __importDefault(require("pino"));
exports.pino = pino_1.default;
// The goal is to ensure ONLY one version of the logging library is loaded at any time
const isJest = typeof jest !== 'undefined';
if (!isJest && process.env.CDF_MONOREPO !== 'true' && globalThis.CVENT_CDF_LOGGING_LIBRARY_LOADED) {
    const errorMessage = '@cvent/logging module was already loaded, it is being loaded again indicating an issue. This likely happening due to multiple different versions which is not supported';
    throw Error(errorMessage);
}
globalThis.CVENT_CDF_LOGGING_LIBRARY_LOADED = true;
/**
 * A map of id's to weak refs to loggers. Used to dynamically change logging levels of loggers not collected by GC.
 */
const loggers = new Set();
// for testing only
async function waitForLoggersToGC() {
    if (!isJest) {
        throw new Error('This function is only intended to be used in jest tests');
    }
    while (loggers.size > 0) {
        // eslint-disable-next-line no-await-in-loop
        await new Promise(resolve => {
            setTimeout(resolve, 500);
        });
    }
    return true;
}
exports.waitForLoggersToGC = waitForLoggersToGC;
const loggerRegistry = new FinalizationRegistry((ref) => {
    loggers.delete(ref);
});
let thisLoggerConfig;
/**
 * Used to set the internal state of the library. This state is set once, and shared between the CJS and ESM
 * version of the library.
 */
function initializeConfig(loggerConfig) {
    if (!thisLoggerConfig) {
        thisLoggerConfig = loggerConfig;
    }
}
exports.initializeConfig = initializeConfig;
/**
 * Returns the initialized configuration.
 */
function getConfig() {
    return thisLoggerConfig;
}
exports.getConfig = getConfig;
/**
 * Add a logger to the list of loggers being tracked.
 */
function addLogger(logger) {
    const ref = new WeakRef(logger);
    loggers.add(ref);
    loggerRegistry.register(logger, ref);
}
exports.addLogger = addLogger;
/**
 * Reset log level on loggers affected by log level changes made using `setLogLevel()`.
 */
function resetActiveLoggersToOriginalLevel() {
    loggers.forEach(ref => {
        const logger = ref.deref();
        if (!logger?.originalLevel) {
            return;
        }
        logger.level = logger.originalLevel;
    });
}
exports.resetActiveLoggersToOriginalLevel = resetActiveLoggersToOriginalLevel;
function setLogLevel(level, loggerName) {
    loggers.forEach(ref => {
        const logger = ref.deref();
        // dead loggers
        if (!logger) {
            return;
        }
        // all loggers
        if (!loggerName) {
            logger.level = level;
            return;
        }
        // string test
        if (typeof loggerName === 'string') {
            if (logger.bindings() && logger.bindings().name === loggerName) {
                logger.level = level;
            }
            return;
        }
        // regex test
        // eslint-disable-next-line no-param-reassign
        loggerName.lastIndex = 0;
        if (logger.bindings() && loggerName.test(logger.bindings().name)) {
            logger.level = level;
        }
    });
}
exports.setLogLevel = setLogLevel;
//# sourceMappingURL=state.cjs.map